var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "slider-buttons" },
    [
      _c("div", {
        class: [
          _vm.classButtons ? _vm.classButtons : "slider-buttons__button",
          _vm.classButtonPrev
            ? _vm.classButtonPrev
            : "slider-buttons__button-prev"
        ],
        attrs: {
          onclick: "this.nextElementSibling.__vue__.$parent.onPrevSlide();"
        }
      }),
      _vm._v(" "),
      _c(
        "swiper",
        {
          ref: "refSwiper",
          staticClass: "slider-buttons__content",
          attrs: { options: _vm.options }
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c("div", {
        class: [
          _vm.classButtons ? _vm.classButtons : "slider-buttons__button",
          _vm.classButtonNext
            ? _vm.classButtonNext
            : "slider-buttons__button-next"
        ],
        attrs: {
          onclick: "this.previousElementSibling.__vue__.$parent.onNextSlide();"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }